<template>
  <div class="system-builder__thank-you--section">

    <div class="system-builder__thank-you--container" v-if="alreadySent === false">
      <h1>Thank you for providing feedback.</h1>
      <p>Have fun with your new Compustar system.</p>
    </div>

    <div class="system-builder__thank-you--container" v-else>
      <h1>This request is closed</h1>
      <p>Thank you for providing your feedback.</p>
      <a class="button__solid--blue" @click="goToViewSystem">Request Another Quote</a>
    </div>

  </div>
</template>

<script>
  import store from '../../store'
  import router from '../../router'
  import $ from 'jquery'

  export default {
    components: {},
    name: 'thankYou',
    props: {
      inquiryId: {
        type: String,
        default: ''
      },
      quoteId: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        sharedState: store.state,
        alreadySent: false
      }
    },
    methods: {
      goToViewSystem: function () {
        const currentInquiryId = this.inquiryId
        const currentQuoteId = this.quoteId
        // router.push({name: 'viewSystem', params: {inquiryId: currentInquiryId, quoteId: currentQuoteId}})
        router.push({path: '/view-system/' + currentInquiryId + '/' + currentQuoteId})
      }
    },
    mounted: function () {
      if (this.inquiryId !== undefined && this.inquiryId !== '' && this.inquiryId.length === 45 && this.quoteId !== 0) {
        // Toggle main nav off
        store.toggleMainNav()

        // Inquiry ID supplied, check against DB
        var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php'

        const self = this

        $.ajax({
          url: ajaxUrl,
          type: 'POST',
          dataType: 'text',
          timeout: 7000,
          data: {
            action: 'system-builder-dealer-successful-followup',
            inquiryId: this.inquiryId,
            quoteId: this.quoteId
          },
          cache: false,
          success: function (response) {
            if (response === '"Already Sent"') {
              self.alreadySent = true
            }
            return false
          }
        })
      } else {
        // If no inquiry ID supplied, do route validation
        store.updateCurrentStateRoute('selectVehicle')
        router.push({name: 'selectVehicle'})
        return false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ThankYou.vue?2bee90a8